document.addEventListener('turbolinks:load', function(event) {
  if (typeof gtag === 'function') {
    gtag('config', 'G-W8BF5NZB5V', {
      'page_location': event.data.url,
      'anonymize_ip': true
    })
  }
})
